module.exports = __webpack_public_path__ + "static/media/img1.2e9dbb28.jpg";